import { useCallback, useEffect, useRef } from "react";

/**
 * A custom hook to track the component whether it is mounted.
 * @returns an object with a isMounted function to indicate component is mounted or not.
 */
export const useMountedState = () => {
  const mountedRef = useRef(false);
  const isMounted = useCallback(() => mountedRef.current, []);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return { isMounted };
};
